import {Box, Paper, Typography, LinearProgress} from "@mui/material";
import {PieChart as MuscleIcon} from "@mui/icons-material";
import {colors, borders, shadows} from "../../ui/colors";

const barColors = [
    colors.primary,
    colors.info,
    "#8B5CF6",
    colors.warning,
    colors.success,
    colors.error,
    "#EC4899",
    "#06B6D4",
    "#84CC16",
    colors.neutral,
];

const MuscleBreakdownChart = ({muscleBreakdown}) => {
    if (!muscleBreakdown || muscleBreakdown.length === 0) return null;

    const sorted = [...muscleBreakdown].sort((a, b) => (b.setsCount || 0) - (a.setsCount || 0));
    const maxSets = sorted[0]?.setsCount || 1;

    return (
        <Paper
            elevation={0}
            sx={{
                border: borders.default,
                borderRadius: borders.radius.lg,
                boxShadow: shadows.card,
                overflow: "hidden",
                direction: "rtl",
            }}
        >
            {/* Header */}
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    padding: {xs: "12px 16px", md: "20px 24px"},
                    borderBottom: borders.default,
                }}
            >
                <MuscleIcon sx={{color: colors.textSecondary}}/>
                <Typography sx={{fontSize: "18px", fontWeight: 600, color: colors.textPrimary}}>
                    פילוח שרירים
                </Typography>
            </Box>

            {/* Bars */}
            <Box sx={{padding: {xs: "14px 16px", md: "20px 24px"}, display: "flex", flexDirection: "column", gap: 2}}>
                {sorted.map((muscle, idx) => (
                    <Box key={idx}>
                        <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center", mb: 0.5}}>
                            <Typography sx={{fontSize: "13px", fontWeight: 600, color: colors.textPrimary}}>
                                {muscle.muscleGroupHeb || muscle.muscleGroup}
                            </Typography>
                            <Box sx={{display: "flex", alignItems: "center", gap: 1}}>
                                <Typography sx={{fontSize: "14px", fontWeight: 700, color: colors.textPrimary}}>
                                    {muscle.setsCount}
                                </Typography>
                                <Typography sx={{fontSize: "11px", color: colors.textMuted}}>
                                    סטים
                                </Typography>
                                {muscle.percentage != null && (
                                    <Typography
                                        sx={{
                                            fontSize: "11px",
                                            fontWeight: 600,
                                            color: barColors[idx % barColors.length],
                                            backgroundColor: `${barColors[idx % barColors.length]}15`,
                                            padding: "1px 6px",
                                            borderRadius: borders.radius.full,
                                        }}
                                    >
                                        {Math.round(muscle.percentage)}%
                                    </Typography>
                                )}
                            </Box>
                        </Box>
                        <LinearProgress
                            variant="determinate"
                            value={(muscle.setsCount / maxSets) * 100}
                            sx={{
                                height: 8,
                                borderRadius: 4,
                                backgroundColor: colors.bgHover,
                                "& .MuiLinearProgress-bar": {
                                    backgroundColor: barColors[idx % barColors.length],
                                    borderRadius: 4,
                                },
                            }}
                        />
                    </Box>
                ))}
            </Box>
        </Paper>
    );
};

export default MuscleBreakdownChart;
